import { ToastCustom } from "@components/toaster";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { deleteExpense } from "../services";

export const useDeleteExpense = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: deleteExpense,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["expenses"] });
			toast(
				ToastCustom({
					title: "Sua despesa foi excluída com sucesso!",
					variant: "success",
				})
			);
		},
		onError: () => {
			toast(
				ToastCustom({
					title: "Erro ao excluir despesa",
					variant: "error",
					description: "Não foi possível excluir a despesa. Tente novamente.",
				})
			);
		},
	});
};
